<template>
  <ap-dropdown type="text" :trigger="['click']" class="w-[calc(100%-16px)]">
    <div class="flex items-center h-6 mb-0 max-w-none">
      <ap-button
        type="text"
        class="flex items-center hover:bg-transparent p-0 w-full"
        @click="openMenuWorkspace = !openMenuWorkspace">
        <img v-if="workspaceLogo" :src="workspaceLogo" alt="logo" class="w-6 h-6 rounded" />

        <div
          class="ml-2 overflow-hidden font-medium text-sm text-ellipsis whitespace-nowrap text-black/[0.86]">
          {{ $t("navigation.workspace.member.label", { user_name: workspaceName }) }}
        </div>
        <DownOutlined class="w-[14px] h-[14px] text-[#12121299] mx-1" />
      </ap-button>
    </div>

    <template #overlay>
      <WorkSpaceMenu />
    </template>
  </ap-dropdown>
</template>

<script setup>
import { computed, ref } from "vue"
import { useUserAccountsStore } from "@/stores/userAccounts"
import { DownOutlined } from "@ant-design/icons-vue"
import WorkSpaceMenu from "@/components/RolesAndUsers/WorkSpaceMenu.vue"
import dl_logo from "@/assets/images/logo.svg?url"

const userAccountsStore = useUserAccountsStore()
const openMenuWorkspace = ref(false)
const workspaceName = computed(() => userAccountsStore.workspaceName)
const workspaceLogo = computed(() => userAccountsStore.workspaceLogo ?? dl_logo)
</script>

<style lang="postcss"></style>
